function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import BaseFormControl from 'react-bootstrap/FormControl';
import FormControlErrorWrapper from './FormControlErrorWrapper';
import { useTheme } from './ThemeContext';
import useFormattedPlaceholder from './useFormattedPlaceholder';
import styles from './FormControls.module.scss';
const propTypes = {
  /** The visual style of the input */
  theme: PropTypes.oneOf(['dark', 'hero', 'light']),

  /** Visually style the control as invalid */
  invalid: PropTypes.bool
};
/**
 * The main presentational wrapper for `<input>`s.
 *
 * Provides some additional styling and error states.
 */

const FormControl = React.forwardRef(({
  meta,
  invalid,
  theme: propsTheme,
  placeholder,
  className,
  value,
  ...props
}, ref) => {
  const theme = useTheme(propsTheme);
  const formattedPlaceholder = useFormattedPlaceholder(placeholder);
  return React.createElement(FormControlErrorWrapper, {
    className: className,
    invalid: invalid == null && meta ? meta.invalid : invalid
  }, React.createElement(BaseFormControl, _extends({}, props, {
    ref: ref,
    value: value == null ? '' : value,
    placeholder: formattedPlaceholder,
    className: classNames(styles.formControl, styles[theme])
  })));
});
FormControl.displayName = 'FormControl';
FormControl.propTypes = propTypes;
export default FormControl;